'use client';

import { CheckboxField } from '@/components/ui/Field';

export interface MarketingOptInValue {
  email: boolean;
  sms: boolean;
}

export const NO_MARKETING_OPT_IN: MarketingOptInValue = { email: false, sms: false };

export const SMS_CONSENT_TEXT =
  'Also text me offers. Message & data rates may apply. Reply STOP to opt out. Needs your phone number.';

/**
 * Unticked-by-default marketing consent for lead forms. Texts are only offered
 * once email is ticked, so every opt-in has an email to identify the contact.
 */
export function MarketingOptIn({
  value,
  onChange,
}: {
  value: MarketingOptInValue;
  onChange: (value: MarketingOptInValue) => void;
}) {
  return (
    <div className="flex flex-col gap-3" data-testid="marketing-opt-in">
      <CheckboxField
        name="marketingEmail"
        checked={value.email}
        onChange={(email) => onChange({ email, sms: email && value.sms })}
        label="Email me NEMO LaunchPad news and offers. Unsubscribe anytime."
      />
      {value.email ? (
        <div className="pl-8">
          <CheckboxField
            name="marketingSms"
            checked={value.sms}
            onChange={(sms) => onChange({ ...value, sms })}
            label={SMS_CONSENT_TEXT}
          />
        </div>
      ) : null}
    </div>
  );
}
